import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { MdArrowBack, MdChevronRight, MdSearch, MdFilterList } from 'react-icons/md';
import data from '../data/locations.json';

const LOCATION_OFFSETS = [
  [0, 0],
  [0.0025, -0.0035],
  [-0.002, 0.0045],
  [0.004, 0.0015],
  [-0.003, -0.003],
];

const createTdIcon = () => new L.DivIcon({
  className: '',
  html: `<svg viewBox="0 0 24 36" width="24" height="36" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 0C5.4 0 0 5.4 0 12c0 7.2 12 24 12 24S24 19.2 24 12C24 5.4 18.6 0 12 0z" fill="#008a3e" stroke="white" stroke-width="1.5"/>
    <circle cx="12" cy="12" r="4" fill="white"/>
  </svg>`,
  iconSize: [24, 36],
  iconAnchor: [12, 36],
  popupAnchor: [0, -36],
});

function MapCenterUpdater({ center }) {
  const map = useMap();
  useEffect(() => {
    map.setView(center, 14);
  }, [center, map]);
  return null;
}

const LocationsScreen = ({ onNavigate, onBack }) => {
  const [searchQuery, setSearchQuery] = useState('Toronto');

  const getLocationsForQuery = (query) => {
    const normalizedQuery = query.toLowerCase().trim();

    if (!normalizedQuery) {
      return data.locationsData['Toronto'] || { locations: [], coordinates: null };
    }

    const city = Object.keys(data.locationsData).find(city =>
      city.toLowerCase().startsWith(normalizedQuery)
    );

    return city ? data.locationsData[city] : { locations: [], coordinates: null };
  };

  const locationData = getLocationsForQuery(searchQuery);
  const locations = locationData.locations || [];
  const coordinates = locationData.coordinates;

  const defaultCoords = { lat: 43.6413, lng: -79.3893 };
  const mapCenter = coordinates || defaultCoords;
  const visibleLocations = locations.slice(0, 5);
  const tdIcon = createTdIcon();

  return (
    <div className="screen locations-screen bh-flow">
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <button className="bh-flow-back" onClick={onBack || (() => onNavigate('home'))} aria-label="Back to home">
            <MdArrowBack />
          </button>
          <h1 className="bh-flow-title">Locations</h1>
        </div>
        <button className="bh-flow-back" aria-label="Filter locations">
          <MdFilterList />
        </button>
      </header>
      <div className="search-bar-container">
        <div className="search-bar">
          <MdSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search TD locations in Canada"
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
          />
        </div>
      </div>
      <div className="map-container">
        <MapContainer
          center={[mapCenter.lat, mapCenter.lng]}
          zoom={14}
          style={{ width: '100%', height: '200px' }}
          zoomControl={false}
          scrollWheelZoom={false}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          />
          <MapCenterUpdater center={[mapCenter.lat, mapCenter.lng]} />
          {visibleLocations.map((loc, i) => {
            const offset = LOCATION_OFFSETS[i] || [0, 0];
            const pos = [mapCenter.lat + offset[0], mapCenter.lng + offset[1]];
            return (
              <Marker key={i} position={pos} icon={tdIcon}>
                <Popup>
                  <strong>{loc.address}</strong><br />
                  {loc.city}<br />
                  <span style={{ color: '#008a3e' }}>{loc.status}</span>
                </Popup>
              </Marker>
            );
          })}
        </MapContainer>
      </div>
      <div className="scroll-content white-bg">
        <div className="list-group-title">Nearby TD Locations</div>
        {locations.length === 0 ? (
          <div style={{padding: '20px', textAlign: 'center', color: 'var(--text-medium)'}}>
            Enter a city or address to find nearby TD Bank locations
          </div>
        ) : (
          visibleLocations.map((loc, i) => (
            <div key={i} className="location-list-item">
              <div className="loc-info">
                <div className="loc-address">{loc.address}</div>
                <div className="loc-city">{loc.city}</div>
                <div className="loc-status">{loc.status}</div>
              </div>
              <div className="loc-dist">{loc.dist} <MdChevronRight /></div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default LocationsScreen;
